import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black tracking-wide">
                兔六影院
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              兔六影院是专注于影视内容浏览与介绍的门户平台，聚合海量电影与电视剧信息，
              提供分类筛选、关键词搜索与作品详情，帮助影迷快速发现值得一看的好作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              快速导航
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/" className="text-primary-200 hover:text-accent-400 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-primary-200 hover:text-accent-400 cursor-pointer">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-primary-200 hover:text-accent-400 cursor-pointer">
                  电视剧分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-primary-200 hover:text-accent-400 cursor-pointer">
                  影视搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              联系我们
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-primary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                support@tuliucinema.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400"></i>
                400-666-8899
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                北京市朝阳区影世界大厦 18 层
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 兔六影院 TuLiu Cinema. 本站内容均为演示数据，仅供学习交流。</p>
          <p>影视信息展示平台 · 不提供内容存储与在线播放服务</p>
        </div>
      </div>
    </footer>
  );
}